import { Form } from "antd";
import SelectCustom from "../../../Common/SelectCustom/SelectCustom";
import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../../context/GlobalContext";
import { getProductType } from "../../../../api/api";
import { useTranslation } from "react-i18next";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import AddIcon from "../../../../assets/AddIcon.svg";
import DisableAddIcon from "../../../../assets/DisableAddIcon.svg";
import xIcon from "../../../../assets/x-icon.svg";
import { sendEmail } from '../../../../api/api';
import RadioCustom from "../../../Common/RadioCustom/RadioCustom";

const win: any = window;

const Mobile: React.FC<any> = () => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const { rtl, productType } = state;
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const dir = rtl ? "right" : "left";
    const nextPage = t("Delivery_Details");
    const modalOpen = false;
    const [packageNameOptions, setPackageNameOptions] = useState([]);
    const [productDataAll, setProductDataAll] = useState([]);
    const [simTypeOptions, setSimTypeOptions] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState<any>({});
    const [productList, setProductList] = useState(state?.productBackListData);
    const [isProductListFull, setIsProductListFull] = useState(false);
    const initialValues = {
        packageName: '',
        simType: '',
        quantity: '',
        orderType: 'New Activation'
    };

    useEffect(() => {
        dispatch({ type: "LOADER", payload: { loading: true } });

        getProductType().then((res) => {
            const productOpt: any = res.data;
            setProductDataAll(productOpt.data);
            // for product type
            var flags = [],
                output = [];
            for (var i = 0; i < productOpt.data.products_list.length; i++) {
                if (flags[productOpt.data.products_list[i].product_type]) continue;
                flags[productOpt.data.products_list[i].product_type] = true;
                let obj = { value: "", name: "" };
                obj.value = productOpt.data.products_list[i].product_type.trim();
                rtl
                    ? (obj.name = productOpt.data.products_list[i].product_type_ar.trim())
                    : (obj.name = productOpt.data.products_list[i].product_type_en.trim());
                output.push(obj);
            }

            // for package type
            if (output.length > 0) {
                var packageOption = [];
                // packageOption.push({ value: "", name: t("Please_select_package") });
                for (var j = 0; j < productOpt.data.products_list.length; j++) {
                    if (productOpt.data.products_list[j].product_type === productType) {
                        var opt = {
                            value: "",
                            name: "",
                            productName: "",
                            price: '',
                            text: ''
                        };
                        opt.name = opt.value = opt.text = rtl
                            ? (productOpt.data.products_list[j].product_name_ar)
                            : (productOpt.data.products_list[j].product_name_en);
                        opt.price = productOpt.data.products_list[j].mrc;
                        packageOption.push(opt);
                    }
                }
                setPackageNameOptions(packageOption);
            }

            updateSimTypeOptions(productOpt.data.products_list[0].sim_types);

            dispatch({ type: "LOADER", payload: { loading: false } });
        });
    }, [dispatch, rtl, t]);

    let simOption = simTypeOptions;

    const updateSimTypeOptions = (simTypes: any) => {
        // for sim type
        var simOption = [];
        for (var k = 0; k < simTypes.length; k++) {
          let sim = { value: "", name: "", simType: "", text: "" };
          sim.value =
            simTypes[k].sim_type_sfa_id;
          sim.simType = simTypes[k].sim_type;
          sim.text = sim.name = rtl
            ? (simTypes[k].sim_type_ar)
            : (simTypes[k].sim_type_en);
          simOption.push(sim);
        }
        setSimTypeOptions(simOption);
    }

    const handlechange = (value: any, formName: string, fieldName: string) => {
        form.setFieldValue(fieldName, value);
        if (fieldName === 'packageName') {
          const jsonResData: any = productDataAll;
          const packageResponse = jsonResData.products_list.filter((res: any) => rtl ? res.product_name_ar === value : res.product_name_en === value)[0];
          if (packageResponse) {
            const simType = packageResponse.sim_types.filter((item: any) => {
              return (item.sim_type_sfa_id === form.getFieldValue('simType'))
            })[0];
            updateSimTypeOptions(packageResponse.sim_types);
            const packageData: any = {};
            packageData.price = packageResponse.mrc;
            packageData.mrc = packageResponse.mrc;
            packageData.nrc = packageResponse.nrc;
            packageData.mode_sfaId = packageResponse.mode_sfa_id;
            packageData.product_Id = packageResponse.product_id;
            packageData.packageType_sfaId = packageResponse.package_type_sfa_id;
            packageData.name = value;
            packageData.simType_sfa = simType?.sim_type_sfa_id;
            packageData.simType_value = simType?.sim_type;
            setSelectedPackage(packageData);
          } else {
            form.setFields([
              {
                name: 'quantity',
                value: '',
                errors: [t('Package_Not_Available')],
              }
            ])
          }
        }
    };
    const sendNotificationRequest = (productList: any) => {
        const env_value = win['environment_value'];
        let crNumber, mobileNumber, address, firstName, lastName, email, companyName, idNumber, kamEmail;
        if (state.customerType === 'newcustomer') {
          crNumber = state.newCustomerData.crNumber;
          mobileNumber = state.newCustomerData.mobileNumber;
          address = `${state.newCustomerData.caCity}, ${state.newCustomerData.nationality}`;
          firstName = state.newCustomerData.firstName;
          lastName = state.newCustomerData.lastName;
          email = state.newCustomerData.email;
          companyName = state.newCustomerData.companyName;
          idNumber = state.newCustomerData.idNumber;
          kamEmail = env_value === 'PROD' ? ['DigitalSalesB2B@Mobily.com.sa'] : ['a.hegde@mobily.com.sa'];
        } else {
          const data = state.accountDetails;
          const category = data.CustomerCategory.toLowerCase();
          kamEmail = category !== 'smb unmanaged' ? data.ListOfKAMs.filter((el: any) => el.IsPrimary === 'Y' && el).map((el: any) => el.EmailAddress) : env_value === 'PROD' ? ['DigitalSalesB2B@Mobily.com.sa'] : ['a.hegde@mobily.com.sa'];
          const personalDetail1 = data.ListOfAPs.filter((el: any) => el.IsPrimary === 'Y' && el)[0];
          const personalDetail2 = data.ListOfAddresses.filter((el: any) => el.IsPrimary === 'Y' && el)[0];
          const personalDetails = { ...personalDetail1, ...personalDetail2 }
          crNumber = data.IDDocumentNumber;
          mobileNumber = personalDetails.Mobile;
          address = `${personalDetails.City}, ${personalDetails.Country}`;
          firstName = personalDetails.FirstName;
          lastName = personalDetails.LastName;
          email = personalDetails.EmailAddress;
          companyName = data.CompanyName;
          idNumber = personalDetails.APIDNumber;
        }
        const product = productList.map((el: any) => {
          return {
              product: el.productInformation.productType?.value,
              order: el.productInformation.orderType?.value,
              package: el.productInformation.packageName.value,
              sim: el.productInformation.simType.value,
              quantity: el.productInformation.quantity.value
          }
        });
        const productTotal = product.length;
        
        const params = [
          {
              "name": "customerType",
              "value": state.customerType === 'newcustomer' ? "New" : "Existing"
          },
          {
              "name": "companyCR",
              "value": crNumber
          },
          {
              "name": "contactNum",
              "value": mobileNumber
          },
          {
              "name": "address",
              "value": address
          },
          {
              "name": "firstName",
              "value": firstName
          },
          {
              "name": "lastName",
              "value": lastName
          },
          {
              "name": "email",
              "value": email
          },
          {
              "name": "companyName",
              "value": companyName
          },
          {
              "name": "number",
              "value": idNumber
          },
          {
              "name": "productsSize",
              "value": productTotal
          }
        ];
        const productParams = product.map((el: any, index: number) => {
          return {
              name: `product${index + 1}`,
              value: `${el.product}, ${el.order}, ${el.package}, ${el.sim}, ${el.quantity}`
          }
        });
        const reqBody = {
          "notifications": [
              {
                  "notificationId": "525617",
                  "notificationType": "EMAIL",
                  "sender": " BusinessWebsite@mobily.com.sa",
                  "header": "Digital Sales request attempt from mobily business website",
                  "receivers": kamEmail,
                  "bccreceivers": env_value === 'PROD' ? ["b2bcex@mobily.com.sa"] : ['123@gmail.com'],
                  params: [...params, ...productParams]
              }
          ]
        }
        sendEmail(reqBody).then((res: any) => {
          if (res.status === 204) {
              
          } else {
              console.log(res)
              const errorMsg = res.status === 401 ? rtl==='right' ? res.status.arabicDetail : res.status.englishDetail : '';
              Error(errorMsg)
              dispatch({ type: 'LOADER', payload: { loading: false } });
          }
        });
      }
      const handleNext = async () => {
        if (productList.length === 0) {
          try {
            const res = await form.validateFields();
            const selectedSimType = simTypeOptions.filter((s: any)=>s.value===res.simType);
            const simTypeText = selectedSimType.length ? selectedSimType[0].text : ''
            const newList = productList.concat({
              productInformation: {
                productType: { value: productType },
                orderType: { value: res.orderType},
                simType: { value: res.simType, text: simTypeText},
                quantity: { value: res.quantity},
                packageName: { ...selectedPackage, value: res.packageName }
              }
              
            });
            dispatch({
              type: "PRODUCT_INFORMATION",
              payload: { values: newList, productList: newList, page: nextPage, productFormData: res, modalOpen }
            });
            sendNotificationRequest(newList);
          } catch (error) {
            console.log(error);
          }
        } else {
          if (productList.length < 5) {
            if (form.getFieldsError().filter(({ errors }) => errors.length)
            .length > 0) {
              dispatch({
                type: "PRODUCT_INFORMATION",
                payload: { values: productList, productList, page: nextPage, modalOpen }
              });
              
              sendNotificationRequest(productList);
            } else {
              const values = await form.getFieldsValue();
              const selectedSimType = simTypeOptions.filter((s: any)=>s.value===values.simType);
              const simTypeText = selectedSimType.length ? selectedSimType[0].text : ''
              const newList = values.packageName && values.quantity && values.simType ? productList.concat({
                productInformation: {
                  productType: { value: productType },
                  orderType: { value: values.orderType},
                  simType: { value: values.simType, text: simTypeText},
                  quantity: { value: values.quantity},
                  packageName: { ...selectedPackage, value: values.packageName }
                }
              }) : productList;
              dispatch({
                type: "PRODUCT_INFORMATION",
                payload: { values: newList, productList: newList, page: nextPage, modalOpen }
              });
              sendNotificationRequest(productList);
            }
          } else {
            setIsProductListFull(true)
            dispatch({
              type: "PRODUCT_INFORMATION",
              payload: { values: productList, productList, page: nextPage, modalOpen }
            });
            sendNotificationRequest(productList);
          }
        }
      };
    
      const handleDeleteProductItem = (index: number) => {
        const mylist = productList;
        delete mylist[index];
        setProductList(mylist.filter((element: any) => element !== null));
        setIsProductListFull(false);
      };
    
      const ProductAddFunction = async () => {
        if (productList.length < 5) {
          try {
            let res = await form.validateFields();
            const selectedSimType = simTypeOptions.filter((s: any)=>s.value===res.simType);
            const simTypeText = selectedSimType.length ? selectedSimType[0].text : ''
            const newList = productList.concat({
              productInformation: {
                productType: { value: productType },
                orderType: { value: res.orderType},
                simType: { value: res.simType, text: simTypeText},
                quantity: { value: res.quantity},
                packageName: { ...selectedPackage, value: res.packageName }
              }
            });
            setProductList(newList);
            form.resetFields();
          } catch (errors) {
            console.log(errors);
          }
        } else setIsProductListFull(true);
      }
    
      const handleAddProductItem = () => {
        ProductAddFunction();
      };

    return (
        <div className="row ms-4">
            <div className="col-md-7">
                <Form form={form} name="accordionForm" initialValues={initialValues}>
                    {productType === 'Voice' &&
                      <RadioCustom
                        dir={dir}
                        headingleft={t("migrate_lines_to_other")}
                        name="orderType"
                        options={[
                          {value: 'New Activation', label: t('New_Numbers')},
                          {value: 'transferToMobily', label: t('Transfer_to_Mobily')}
                        ]}
                        defaultValue="New Activation"
                      />
                    }
                    <SelectCustom
                        headingLeft={t('Package_Name')}
                        name="packageName"
                        options={packageNameOptions}
                        placeholder={`${t('Choose_a_package')}`}
                        handleChange={(value: any) => {
                            handlechange(value, "productInformation", "packageName");
                        }}
                        rules={[
                            { required: true, message: `${t("Please_Enter")} ${t("Package_Name")}` },
                        ]}
                    />
                    <SelectCustom
                        headingLeft={t('SIM_Type')}
                        name="simType"
                        options={simOption}
                        placeholder={`${t('Choose_a_type')}`}
                        handleChange={(value: any) => {
                            handlechange(value, "productInformation", "simType");
                        }}
                        rules={[
                            { required: true, message: `${t("Please_Enter")} ${t("SIM_Type")}` },
                        ]}
                    />
                    <SelectCustom
                        headingLeft={t('Quantity')}
                        name="quantity"
                        options={Array.from({ length: 10 }, (_, i) => { return { text: i + 1 } })}
                        placeholder={`${t('Choose_the_Quantity')}`}
                        handleChange={(value: any) => {
                            handlechange(value, "productInformation", "quantity");
                        }}
                        rules={[
                            { required: true, message: `${t("Please_Enter")} ${t("Quantity")}` },
                        ]}
                    />
                    <div
                        className={productList.length >= 4 ? `add-another-product-btn product-btn-ar-${dir} addBtn_disable` : `add-another-product-btn product-btn-ar-${dir}`}
                        onClick={handleAddProductItem}
                    >
                        <img className={`add-another-product-btn-icon product-btn-icon-ar-${dir}`} src={productList.length >= 4 ? DisableAddIcon : AddIcon} alt="Add" />
                        {t("Add_Another_Product")}
                    </div>
                    <div className="product-submit-error-container">
                        <Typography rtl={rtl} className="product-submit-error-text sansFont">
                            {isProductListFull ? t("Not_Allowed_More") : ""}
                        </Typography>
                    </div>
                    <IconButton width={"130px"} htmlType='button' onClick={handleNext} rtl={rtl} className="next-button mt-2">
                        {t("Next")}
                    </IconButton>
                </Form>
            </div>
            <div className="col-md-5">
                <div className="product-item-main-container">
                    {console.log(productList, 'productList')}
                    {productList.map((item: any, index: number) => {
                        const product = item?.productInformation;
                        return (
                          <div
                              key={"list-item-" + index}
                              className="product-item-container"
                          >
                              <div className="product-item-text-container">
                                  <Typography className="product-item-text sansFont">
                                      {product?.packageName?.value} &nbsp;/
                                      &nbsp;
                                      {product?.quantity?.value} &nbsp;
                                      {product?.quantity?.value === 1
                                          ? t("Line")
                                          : t("Lines")}
                                  </Typography>
                              </div>
                              <div className="product-item-btn-container">
                                  <img
                                      onClick={() => handleDeleteProductItem(index)}
                                      className="product-item-delete-btn"
                                      src={xIcon}
                                      alt=""
                                  ></img>
                              </div>
                        </div>
                      )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Mobile;
